var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopTrustpilotStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 37.012L36.519 34.2195L41.1227 48.4082L25.5001 37.012ZM50.8586 18.6724H31.4623L25.5001 0.408203L19.5378 18.6724H0.141602L15.8397 29.9931L9.87744 48.2573L25.5756 36.9365L35.2359 29.9931L50.8586 18.6724Z",
    fill: "#EBF1F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTrustpilotStar);
export default __webpack_public_path__ + "static/media/topTrustpilotStar.20d0f0e1d41a82f33d52f7f1d6db76b7.svg";
export { ForwardRef as ReactComponent };